export const oneMonthAgoDate = () => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  return oneMonthAgo;
};

export const oneDayAgoDate = () => {
  let oneDayAgo: any = new Date();
  oneDayAgo.setDate(oneDayAgo.getDate() - 1);
  oneDayAgo.setHours(0, 0, 0, 0);
  return oneDayAgo;
};

export const todayDate = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
};

export const startToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const endToday = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
};

export const oneWeekAgoDate = () => {
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  oneWeekAgo.setHours(0, 0, 0, 0);
  return oneWeekAgo;
};

export const endOfToday = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
};
